/** Raises a click event. */
export function raiseClick(target) {
  var event = new Event('MouseEvents');
  event.initEvent('click', true, true);
  target.dispatchEvent(event);
}